import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { StatusModalComponent } from './status-modal/status-modal.component';
import { OkModalComponent } from './ok-modal/ok-modal.component';
import { NoButtonModalComponent } from './no-button-modal/no-button-modal.component';
import { ImageModalComponent } from './image-modal/image-modal.component';
import { NoHeaderModalComponent } from './no-header-modal/no-header-modal.component';
import { OkHtmlModalComponent } from './ok-html-modal/ok-html-modal.component';
import { GenericComponentsRoutingModule } from './generic-components-routing.module';
import { AttemptModalComponent } from './attempt-modal/attempt-modal.component';
import { LateModalComponent } from './late-modal/late-modal.component';
import { AuthInterceptorProvider } from '../services/token/token-interceptor.service';

@NgModule({
    declarations: [AttemptModalComponent, ConfirmationModalComponent, LateModalComponent, ImageModalComponent, NoButtonModalComponent, NoHeaderModalComponent, OkModalComponent, OkHtmlModalComponent, StatusModalComponent],
    imports: [
        CommonModule,
        GenericComponentsRoutingModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    providers: [
        AuthInterceptorProvider,
    ]
})
export class GenericComponentsModule { }


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
